module.exports = __webpack_public_path__ + "static/media/back_03.a3eaa27b.png";